/* eslint-disable */
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { AlertSites, NotificationTypes, SiteWideNotification } from './notification-models';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';

const removedAlert = 'Removed_Alert';

interface Props {
	setSiteNotificationClosed: any;
	site: AlertSites;
	noReactLink?: boolean;
	useModal?: boolean;
}
export function SiteWideNotifications(props: Props) {
	const { site, setSiteNotificationClosed, noReactLink, useModal } = props;
	const siteWideAlerts = useSelector<TcsmStates, SiteWideNotification[]>(state => state?.epiProps?.siteSettingsState?.siteSettings?.siteWideAlerts);
	const [dismissed, updateDismissed] = useState(sessionStorage.getItem(removedAlert));

	const now = new Date();

    function ActiveNotification(siteWideNotification: SiteWideNotification): boolean {
        const startDate = siteWideNotification.startDateTime ? new Date(siteWideNotification.startDateTime) : null;
        const endDate = siteWideNotification.endDateTime ? new Date(siteWideNotification.endDateTime) : null;

		if ((startDate && now < startDate) || (endDate && now > endDate)) return false;

		return !dismissed?.split('|').includes(`${siteWideNotification.alertType}${siteWideNotification.alertTitle}`);
	}

	function currentSiteOnly(siteWideNotification: SiteWideNotification): boolean {
		return siteWideNotification?.siteToEnable === AlertSites.ALL || siteWideNotification?.siteToEnable === site;
	}

	const filteredAlerts = siteWideAlerts?.filter(ActiveNotification)?.filter(currentSiteOnly);

	const dismissSiteWideAlert = (key: string) => {
		let dismissedSaved = sessionStorage.getItem(removedAlert);
		dismissedSaved = `${dismissedSaved}|${key}`;
		sessionStorage.setItem(removedAlert, dismissedSaved);
		updateDismissed(dismissedSaved);
		setSiteNotificationClosed && setSiteNotificationClosed(true);
	};

	const renderIcon = (alertType: NotificationTypes) => {
		switch (alertType) {
			case NotificationTypes.URGENT:
				return { icon: <ErrorIcon />, className: 'sitewide-notification-urgent' };
			case NotificationTypes.INFORMATION:
				return { icon: <InfoIcon />, className: 'sitewide-notification-info' };
			case NotificationTypes.POSITIVE:
				return { icon: <CheckCircleIcon />, className: 'sitewide-notification-positive ' };
			case NotificationTypes.WARNING:
				return { icon: <WarningIcon />, className: 'sitewide-notification-warning' };
			default:
				return null;
		}
	};
	const siteWideNotification = (notification: SiteWideNotification) => {
		const iconProps = renderIcon(notification.alertType);

		return (
			<div className={`sitewide-notification ${iconProps.className}`}>
				<div className='sitewide-notification-inner'>

					<div className='sitewide-notification-content'>
						<div className='sitewide-notification-icon'>
							{iconProps.icon}
						</div>
						<div className='sitewide-notification-content-inner'>

							<h5 className='sitewide-notification-content-header'>{notification?.alertTitle}</h5>
							<div className='sitewide-notification-content-description'>
								{noReactLink ?
									<div dangerouslySetInnerHTML={{ __html: notification?.alertDescription }} className='rich-text' /> :
									<WysiwygWithReactLink content={notification?.alertDescription} />}
							</div>
						</div>
					</div>
					<button className='sitewide-notification-close' type='button' onClick={() => dismissSiteWideAlert(`${notification?.alertType}${notification?.alertTitle}`)}><span className='visually-hidden'>Close</span>
						<svg focusable='false'>
							<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#close-icon' />
						</svg>
					</button>
				</div>
			</div>

		);

	};
	return <>{filteredAlerts?.map((a, idx) => <div key={idx}>{siteWideNotification(a)}</div>)}</>;

}

SiteWideNotifications.defaultProps = {
	noReactLink: false,
	useModal: false,
};